<div class="recoverAccount__body">
  <idp-login-header
    [loginHeaderContent]="pageData"
    (triggerClose)="triggerClose.emit()"
    [machCore]="machCore"
  ></idp-login-header>
  <section
    id="recoverAccountSection"
    class="recoverAccount__section--message"
    [innerHTML]="
      emailExpired
        ? pageData.message.emailExpired
        : pageData.wifiPortal
        ? pageData.message.wfp
        : pageData.message.modal
    "
  ></section>
  <div class="recoverAccount__cta--button">
    <idp-button
      [label]="pageData.wifiPortal ? 'CONNECT' : 'OK'"
      [size]="'full-width'"
      (notify)="submit()"
    ></idp-button>
  </div>
</div>
